import { Component, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';

@Component({
  selector: 'form-control-button',
  templateUrl: './form-control-button.component.html',
  styleUrls: ['./form-control-button.component.scss']
})
export class FormControlButtonComponent implements OnInit {
  @Input('dialog') dialogRefThis:MatDialog;
  constructor() { }

  ngOnInit() {

  }

  close() {
  //  this.dialogRefThis.closeAll();
  }

}
